export interface HeatMapData {
    [likelihoodEnum: number]: {
        [impactEnum: number]: {
            focus: number;
            all: number;
        };
    };
}

export const INHERENT_MODE = "inherent";
export const RESIDUAL_MODE = "residual";

export type MapMode = typeof INHERENT_MODE | typeof RESIDUAL_MODE;
